import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponseWithPagination } from 'services/api/types';
import type {
  CreateMunicipalityBody,
  Municipality,
  MunicipalityWithRegion,
  MunicipalitiesListRequest,
  UpdateMunicipalityBody,
} from './types';

export const getMunicipalitiesList = (
  params: MunicipalitiesListRequest = {},
): Promise<ListResponseWithPagination<Municipality>> => {
  return appApi
    .get('/municipalities', {
      params,
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить муниципалитеты' });
      throw error;
    });
};

export const getMunicipalitiesWithRegionsList = (
  params: MunicipalitiesListRequest = {},
): Promise<ListResponseWithPagination<MunicipalityWithRegion>> => {
  return appApi
    .get('/municipalities/with-region', {
      params,
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить муниципалитеты' });
      throw error;
    });
};

export const getMunicipalities = (): Promise<ListResponseWithPagination<Municipality>> => {
  return appApi
    .get('/municipalities')
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить муниципалитеты' });
      throw error;
    });
};

export const getMunicipalityById = (municipalityId: number): Promise<Municipality> => {
  return appApi
    .get(`/municipalities/${municipalityId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить муниципалитет' });
      throw error;
    });
};

export const createMunicipality = (body: CreateMunicipalityBody): Promise<Municipality> => {
  return appApi
    .post('/municipalities', body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать муниципалитет' });
      throw error;
    });
};

export const createMunicipalityWithRegion = (
  body: CreateMunicipalityBody,
): Promise<MunicipalityWithRegion> => {
  return appApi
    .post('/municipalities/with-region', body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать муниципалитет' });
      throw error;
    });
};

export const updateMunicipality = (
  municipalityId: number,
  body: UpdateMunicipalityBody,
): Promise<Municipality> => {
  return appApi
    .put(`/municipalities/${municipalityId}`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить муниципалитет' });
      throw error;
    });
};

export const updateMunicipalityWithRegion = (
  municipalityId: number,
  body: UpdateMunicipalityBody,
): Promise<MunicipalityWithRegion> => {
  return appApi
    .put(`/municipalities/${municipalityId}/with-region`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить муниципалитет' });
      throw error;
    });
};

export const patchMunicipality = (
  municipalityId: number,
  body: Partial<UpdateMunicipalityBody>,
): Promise<Municipality> => {
  return appApi
    .patch(`/municipalities/${municipalityId}`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить муниципалитет' });
      throw error;
    });
};

export const patchMunicipalityWithRegion = (
  municipalityId: number,
  body: Partial<UpdateMunicipalityBody>,
): Promise<MunicipalityWithRegion> => {
  return appApi
    .patch(`/municipalities/${municipalityId}/with-region`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить муниципалитет' });
      throw error;
    });
};

export const removeMunicipality = (municipalityId: number): Promise<void> => {
  return appApi
    .delete(`/municipalities/${municipalityId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить муниципалитет' });
      throw error;
    });
};
